<template>
    <el-card class="form-card">
        <div class="form-preview"
         @click="selectActivity">
            <!-- 设备信息 -->
            <div class="midPart-device">
                <img src="http://file.ibabygroup.cn/Mobbig/commons/xpZ7azGRFURrbwgKw9ad5BX8AsDv8r5y.jpeg">
            </div>

            <!-- 内容区域 -->
            <div class="form-content">
                <!-- 活动信息区域 -->
                <div class="form-activity">
                    <!-- 封面 -->
                    <img :src="commonUrl.imgPrefix + info.banner"
                    v-show="info.banner"
                    class="banner">
                    <!-- 标题 -->
                    <div class="title"
                    v-show="info.name">{{info.name}}</div>
                    <!-- 简介 -->
                    <div class="summary"
                    v-show="info.descInfo"
                    v-html="info.descInfo"></div>
                </div>
                
                <!-- 组件信息 -->
                <el-form disabled>
                    <div
                     v-for="(item, index) in componentsList"
                     :key="index"
                     @click.stop.prevent="selectComponent(index, item)"
                     :class="['form-item',
                     selectedComponent && selectedComponent.fieldId === item.fieldId ? 'active' : '']">
                        <div class="label">
                            <div>
                                <span class="order">{{orderFilter(index)}}</span>
                                <label for="name">{{item.chName}}</label>
                                <span class="required" v-show="item.isRequired">*</span>
                                <span class="tip" v-if="item.name === 'choice'">
                                    （{{item.type == 5 ? '单选题' : '多选题'}}）
                                </span>
                            </div>
                            <i class="el-icon-close"
                             @click.stop.prevent="removeComponent(index, item)"></i>
                        </div>

                        <!-- 性别 -->
                        <div
                         v-if="item.name === 'sex'"
                         class="choose">
                            <div>男</div>
                            <div>女</div>
                        </div>

                        <!-- 选择题 -->
                        <div v-else-if="item.name === 'choice'"
                         class="select">
                            <div v-for="(option, index) in item.contents"
                             :key="index"
                             class="frame">
                                <span>{{index | indexFilter}}</span>
                                <span>{{option.content}}</span>
                            </div>
                        </div>
                        
                        <!-- 地区 -->
                        <div v-else-if="item.name === 'address'">
                            <div class="frame-inline">
                                <div class="frame">省份</div>
                                <div class="frame">城市</div>
                                <div class="frame">区域</div>
                            </div>
                            <input v-show="item.isFullAddress"
                             placeholder="请输入您的详细地址"
                             disabled>
                        </div>
                        <!-- 证件照 -->
                        <div class="certificate-photo"
                         v-else-if="item.name === 'certificatePhoto'">
                            <div class="auth-preview">
                            </div>
                            <p  class="auth-preview-tip">如您提供的是工作证，需要上传手持工作证照片</p>
                            <div class="auth-example">
                                <div class="auth-example-item">
                                    <img class="auth-card"
                                     src="http://file.ibabygroup.cn/Mobbig/image/tU9RkGAbhAvdC25zR8GSKY5jE8HccqTf.jpg">
                                    <p class="auth-card-desc">
                                        <img src="http://file.ibabygroup.cn/Mobbig/image/STn868ykTVckjWXHLpxj33V64sMWTE88.jpg" alt="正确例子">
                                        <span>标准证件</span>
                                    </p>
                                </div>
                                <div class="auth-example-item">
                                    <img class="auth-card"
                                     src="http://file.ibabygroup.cn/Mobbig/image/B9Fz4SqB9zZ6D2b7cNJzzMUjhEacyxEN.jpg">
                                    <p class="auth-card-desc">
                                        <img src="http://file.ibabygroup.cn/Mobbig/image/YPCXH9RGFNENmkKNAwypRUJRBJe8swLg.jpg" alt="正确例子">
                                        <span>信息缺失</span>
                                    </p>
                                </div>
                                <div class="auth-example-item">
                                    <img class="auth-card"
                                     src="http://file.ibabygroup.cn/Mobbig/image/9cvCeUGNS8Dx6NwKnfr6VyHBLFdRFeVn.jpg">
                                    <p class="auth-card-desc">
                                        <img src="http://file.ibabygroup.cn/Mobbig/image/YPCXH9RGFNENmkKNAwypRUJRBJe8swLg.jpg" alt="正确例子">
                                        <span>模糊不清</span>
                                    </p>
                                </div>
                                <div class="auth-example-item">
                                    <img class="auth-card"
                                     src="http://file.ibabygroup.cn/Mobbig/image/sc8UyPvuzcWC9PLNrakvJ8q5Gx9ehreP.jpg">
                                    <p class="auth-card-desc">
                                        <img src="http://file.ibabygroup.cn/Mobbig/image/YPCXH9RGFNENmkKNAwypRUJRBJe8swLg.jpg" alt="正确例子">
                                        <span>闪光过度</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- 输入框 -->
                        <input
                         v-else
                         type="text"
                         :placeholder="item.comment"
                         :maxlength="item.limitLength"
                         :show-word-limit="item.limitLength ? true : false"
                         disabled>
                    </div>
                </el-form>
            </div>
            
            <!-- 底部按钮 -->
            <div class="footer"
             v-show="info.submitBtnTxt">
                <div class="btn cancel" v-if="!info.isFill">跳过</div>
                <div class="btn submit">{{info.submitBtnTxt}}</div>
            </div>
        </div>
    </el-card>
</template>

<script scoped>
    import commonApi from '@/api/common'
    export default {
        data() {
            return {
                commonUrl: commonApi.commonUrl,
            }
        },
        props: {
            info: {
				type: Object,
				default: () => {}
			},
            componentsList: {
				type: Array,
				default: () => []
			},
            selectedComponent: {
				type: Object,
                default: () => {}
            }
        },
        methods: {
            // 选择修改活动信息
            selectActivity() {
                this.$emit('selectActivity')
            },

            // 选择组件
            selectComponent(index) {
                this.$emit('selectComponent', index)
            },

            // 移除组件
            removeComponent(index, item) {
                this.$emit('removeComponent', index, item)
            },

            // 组件序号
            orderFilter(index) {
                index = index + 1
                if (index > 9) {
                    return index
                } else {
                    return '0' + index
                }
            }
        },
        filters: {
            indexFilter(index) {
                const key = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
                'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
                return key[index]
            }
        }
    }
</script>

<style type="text/less" lang="less">
    @import '../style/form.less';
    .form-card{
        box-sizing: border-box;
        .form-preview{
            height: 670px;
            display: flex;
            flex-direction: column;
        }
        .midPart-device,
        .footer{
            flex: none;
        }
        .form-content{
            flex: 1;
            overflow: auto;
        }
        .form-item{
            box-sizing: border-box;
            border: 1px solid #fff;
            &.active{
            border: 1px solid #409EFF;
        }
        }
    }
    .midPart-device{
        width: 100%;
        img{
            display: flex;
            width: 100%;
        }
    }
    .choose{
        >div{
            cursor: not-allowed;
        }
    }
    .frame{
        cursor: not-allowed;
        background-color: rgba(239, 239, 239, 0.3)
    }
    .auth-preview{
        cursor: not-allowed;
    }
</style>


// WEBPACK FOOTER //
// src/views/operateManage/signupform/components/midPart.vue